import { useEffect, useMemo, useRef, useState } from "react";
import { paint, prepare } from "./tint";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const abs = (u) => (u?.startsWith("/api/") ? `${BACKEND}${u}` : u);

// Recolors only the car body, rims and calipers on a canvas, so the background never changes color
export const useTinted = (base, color, addons, parts) => {
  const prep = useRef(null);
  const [ready, setReady] = useState(false);
  const [canvas, setCanvas] = useState(null);
  useEffect(() => { setReady(false); prepare(abs(base)).then((p) => { prep.current = p; setReady(true); }).catch(() => {}); }, [base]);
  const hex = (id) => addons.find((a) => a.id === id)?.hex || null;
  const key = JSON.stringify([color?.id, hex("wheels"), hex("calipers"), hex("underglow"), ready]);
  useEffect(() => {
    if (!ready) return undefined;
    const t = setTimeout(() => setCanvas(paint(prep.current, { color, wheels: hex("wheels"), calipers: hex("calipers"), glow: hex("underglow"), parts })), 10);
    return () => clearTimeout(t);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return canvas;
};

export const CarPreview = ({ base, render, color, addons, parts, showRender, onCanvas }) => {
  const canvas = useTinted(base, color, addons, parts);
  const url = useMemo(() => (canvas ? canvas.toDataURL("image/jpeg", 0.92) : abs(base)), [canvas, base]);
  useEffect(() => { onCanvas?.(canvas); }, [canvas]); // eslint-disable-line react-hooks/exhaustive-deps
  if (showRender && render) return <img src={abs(render)} alt="Your build" className="absolute inset-0 w-full h-full object-cover" data-testid="builder-render-img" />;
  return <img src={url} alt="Your car" className="absolute inset-0 w-full h-full object-cover transition-opacity duration-300" data-testid="builder-instant-preview" />;
};
